import { call, put, takeLatest, all, select } from 'redux-saga/effects';
import * as actionTypes from '../actionTypes/home';
import config from 'config';
import apiClient from '../helpers/apiClient';
import { getRawHomeData, getMergedHomeData } from '../selectors/home';

let _client = null;
// let _location = null;

function getProcessedData(homePageData, campaignData) {
    const homeSections = homePageData.homeData && homePageData.homeData.sections;
    let campaignDataForThisBlock;
    let campaignDataSize = Object.keys(campaignData).length;
    homeSections.some((section, index) => {
        if (section.blockType && campaignData[section.blockType]) {
            campaignDataForThisBlock = campaignData[section.blockType];
            if (section.blockType !== 'CAROUSEL_BANNER') {
                homeSections[index] = campaignDataForThisBlock;
            } else {
                const homeCarouselData = homeSections[index].data[0].data;
                const newCarouselData = [];
                homeCarouselData.forEach((carouselSlide, idx) => {
                    if (campaignDataForThisBlock[idx]) {
                        newCarouselData.push(campaignDataForThisBlock[idx]);
                    }
                    newCarouselData.push(carouselSlide);
                });
                homeSections[index].data[0].data = newCarouselData;
            }
            campaignDataSize -= 1;
            if (campaignDataSize === 0) {
                return true;
            }
        }
        return false;
    });
    return homePageData;
}

function* getHomepageData(campaignData, usePristineData, pageContext) {
    if (__CLIENT__) sessionStorage.removeItem('isReOrderProduct');
    const successAction = { type: actionTypes.HOMEPAGE_DATA_SUCCESS };
    const errorAction = { type: actionTypes.HOMEPAGE_DATA_FAIL };
    const client = Object.assign({}, _client);
    client.setHeader();
    if (['premium-eyeglasses', 'premium-sunglasses', 'eyeglasses', 'sunglasses', 'home'].includes(pageContext) || pageContext.indexOf('promo-') > -1) {
        try {
            let configPath;
            if (pageContext === 'home') {
                configPath = config.apiPath.homePageJson;
            } else {
                configPath = `${config.jsonPath}/${pageContext}.json`;
            }
            let rawHomeData;
            if (usePristineData) {
                rawHomeData = yield select(getRawHomeData);
            } else {
                rawHomeData = yield call(async () => client.get(`${configPath}?v=${new Date().getTime()}`));
                const categoryCarouselPositions = [];
                const categoryCarouselIds = rawHomeData.homeData.sections.reduce((filtered, section, index) => {
                    if (__SERVER__ && filtered.length > 2) {
                        return filtered;
                    }
                    if (section.data[0].type === 'TYPE_CATEGORY_CAROUSEL') {
                        const catId = section.data[0].data.catId;
                        filtered.push(catId);
                        categoryCarouselPositions.push(index);
                    }
                    return filtered;
                }, []);
                if (categoryCarouselIds && categoryCarouselIds.length) {
                    const ids = __SERVER__ ? categoryCarouselIds.slice(0, 2).join(',') : categoryCarouselIds.join(',');
                    const categoryCarouselsData = yield call(async () => client.get(config.apiPath.categoryCarouselUrl + ids));
                    categoryCarouselPositions.forEach(carouselPosition => {
                        rawHomeData.homeData.sections[carouselPosition].data[0].productData = categoryCarouselsData.result.filter(carouselData => parseInt(carouselData.cat_id, 10) === rawHomeData.homeData.sections[carouselPosition].data[0].data.catId);
                    });
                }
            }
            const rawDataClone = JSON.parse(JSON.stringify(rawHomeData));
            successAction.data = campaignData && campaignData.activeAndValidData && Object.keys(campaignData.activeAndValidData).length ? getProcessedData(rawDataClone, campaignData.activeAndValidData) : rawDataClone;
            successAction.rawData = rawHomeData;
            yield put(successAction);
        } catch (e) {
            errorAction.error = e;
            yield put(errorAction);
        }
    }
}
function* getCarousalsData() {
    const successAction = { type: actionTypes.HOMEPAGE_CAROUSALS_DATA_SUCCESS };
    const errorAction = { type: actionTypes.HOMEPAGE_CAROUSALS_DATA_FAIL };
    const client = Object.assign({}, _client);
    client.setHeader();
    try {
        const rawHomeData = yield select(getRawHomeData);
        const mergedHomeData = yield select(getMergedHomeData);
        const categoryCarouselPositions = [];
        const categoryCarouselIds = rawHomeData.homeData.sections.reduce((filtered, section, index) => {
            if (section.data[0].type === 'TYPE_CATEGORY_CAROUSEL') {
                const catId = section.data[0].data.catId;
                filtered.push(catId);
                categoryCarouselPositions.push(index);
            }
            return filtered;
        }, []);
        if (categoryCarouselIds && categoryCarouselIds.length) {
            const categoryCarouselsData = yield call(async () => client.get(config.apiPath.categoryCarouselUrl + categoryCarouselIds.join(',')));
            categoryCarouselPositions.forEach(carouselPosition => {
                rawHomeData.homeData.sections[carouselPosition].data[0].productData = categoryCarouselsData.result.filter(carouselData => parseInt(carouselData.cat_id, 10) === rawHomeData.homeData.sections[carouselPosition].data[0].data.catId);
                mergedHomeData.sections[carouselPosition].data[0].productData = categoryCarouselsData.result.filter(carouselData => parseInt(carouselData.cat_id, 10) === rawHomeData.homeData.sections[carouselPosition].data[0].data.catId);
            });
        }
        successAction.data = rawHomeData;
        successAction.mergedHomeData = mergedHomeData;
        yield put(successAction);
    } catch (e) {
        errorAction.error = e;
        yield put(errorAction);
    }
}
export function* getHome({ campaignData, usePristineData, pageContext }) {
    yield put({ type: actionTypes.HOMEPAGE_DATA_LOAD });
    yield call(getHomepageData, campaignData, usePristineData, pageContext);
}

function* getMobileHomepageData({ isBot }) {
    const successAction = { type: actionTypes.MOBILE_HOMEPAGE_DATA_SUCCESS };
    const errorAction = { type: actionTypes.HOMEPAGE_DATA_FAIL };
    const timestamp = Math.floor((new Date().getTime() / (60000 * 3))).toString();
    const client = Object.assign({}, _client);
    client.setHeader();
    try {
        const data = yield call(async () => client.get(`${config.apiPath.homePageJson}?v=${timestamp}`));
        successAction.data = data;
        successAction.isBot = isBot;
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}

export function* runHomeCalls(client) {
    _client = client ? Object.assign({}, client) : apiClient();
    yield all([
        takeLatest(actionTypes.MOBILE_HOMEPAGE_DATA_LOAD, getMobileHomepageData),
        takeLatest(actionTypes.HOMEPAGE_CAROUSALS_DATA_LOAD, getCarousalsData)
    ]);
}
